module.exports = {
	"shared.crew.original-music-composer": "Композитор",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "PR",
	"share-overlay.share": "Поделиться видео",
	"shared.crew.associate-producer": "Ассистент продюсера",
	"shared.crew.assistant-editor": "Ассистент редактора",
	"overlay.buy-from": "Покупка от {price}",
	"shared.crew.agent": "Агент",
	"shared.crew.additional-photography": "Ассистент оператора",
	"shared.crew.sound-editor": "Звукорежиссер",
	"shared.crew.print-shipper": "Print Shipper",
	"shared.crew.hairstylist": "Парикмахер",
	"shared.crew.makeup-effects": "Визажист",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "Ассистент продюсера",
	"shared.crew.executive-producer": "Исполнительный продюсер",
	"shared.crew.costumer": "Костюмер",
	"info-overlay.cast": "в ролях",
	"shared.crew.stunt-coordinator": "Постановщик трюков",
	"shared.crew.academic-advisor": "Научный консультант",
	"shared.crew.swing-gang": "Рабочие",
	"shared.crew.best-boy": "Помощник гафера",
	"actions.purchased": "Вы купили видео",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "Декоратор",
	"shared.crew.adaptation": "Адаптация",
	"shared.crew.school-administrator": "Администратор",
	"shared.crew.cable-person": "Кабельмейстер",
	"shared.crew.digital-effects": "Цифровые эффекты",
	"actions.rent": "Прокат: {price}",
	"info-overlay.created-by": "Автор: {author}",
	"social-share.twitter": "Смотрите видео «{title}» в {siteUrl}",
	"shared.crew.production-designer": "Художник-постановщик",
	"info-overlay.crew": "съемочная группа",
	"shared.crew.producer": "Продюсер",
	"shared.crew.2nd-unit-dir-of-photography": "Оператор-постановщик",
	"shared.crew.special-effects": "Спецэффекты",
	"actions.rented": "Доступно до {date}",
	"shared.crew.boom-operator": "Микрофонщик",
	"shared.crew.story": "Сценарий",
	"shared.crew.script-supervisor": "Скрипт",
	"shared.crew.director": "Режиссер",
	"shared.crew.choreographer": "Хореограф",
	"shared.crew.production-manager": "Директор картины",
	"quality.auto": "Auto",
	"shared.crew.lead-person": "Художественный руководитель",
	"shared.crew.location-manager": "Администратор по площадке",
	"shared.crew.costume-designer": "Художник по костюмам",
	"fullscreen.exit": "Выйти из полноэкранного режима",
	"shared.crew.technical-advisor": "Технический консультант",
	"shared.crew.editor": "Редактор",
	"shared.crew.additional-grip": "Механик",
	"actions.buy": "Покупка: {price}",
	"shared.crew.assistant-camera": "Ассистент оператора",
	"shared.crew.writer": "Сценарист",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "Второй режиссер",
	"fullscreen.enter": "Во весь экран",
	"shared.crew.animal-trainer": "Дрессировщик",
	"shared.crew.assistant-art-director": "Ассистент художника-постановщика",
	"shared.crew.key-grip": "Старший механик",
	"social-button.copy": "Копировать",
	"shared.crew.makeup-artist": "Художник-гример",
	"overlay.source-error": "Невозможно запустить видео",
	"social-button.link": "Ссылка",
	"actions.buy-from": "Покупка от {price}",
	"shared.crew.art-director": "Художник-постановщик",
	"shared.crew.production-coordinator": "Производственный помощник",
	"shared.crew.co-director": "Сорежиссер",
	"shared.crew.co-producer": "Сопродюсер",
	"shared.crew.video-operator": "Видеооператор",
	"shared.crew.camera-operator": "Оператор",
	"shared.crew.co-writer": "Соавтор сценария",
	"shared.crew.set-designer": "Художник кинофильма",
	"shared.crew.preview-return": "Preview Return",
	"shared.crew.property-master": "Реквизитор",
	"shared.crew.cinematographer-dp": "Главный оператор",
	"shared.crew.grip": "Механик",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "Звукооператор",
	"quality.label": "Качество",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "Бригадир осветителей",
	"shared.crew.assistant-director": "Ассистент режиссера",
	"actions.subscribe": "Подписаться за {price} в месяц",
	"shared.crew.print-return": "Print Return",
	"shared.crew.animator": "Мультипликатор",
	"shared.crew.dolly-grip": "Дольщик",
	"shared.crew.manager": "Администратор",
	"shared.crew.2nd-assistant-director": "Помощник режиссера",
	"shared.crew.author-of-adapted-material": "Автор адаптации"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_ru.json
// module id = 1448
// module chunks = 0 1 2 3